((Drupal) => {
  Drupal.behaviors.nrwfChoices = {
    attach: (context) => {

      once('nrwf-choices', '.form-select', context).forEach(($element) => {
        // const element = document.querySelector('.js-choice');
        const $hasSearch = $element.getAttribute('data-has-search') ?? false;
        const choices = new Choices($element, {
          itemSelectText: '',
          searchEnabled: $hasSearch,
          shouldSort: false,
          fuseOptions: {
            threshold: 0.1,
            distance: 1000
          }
        });
      });

    },
  };
})(Drupal);
